<style scoped>
.noline{
  white-space:nowrap;  
}

th{
  white-space:nowrap;
}

.table-responsive { 
            height:600px;
            overflow:scroll;
}
.fijo{
    position:sticky; 
    top:0; 
    z-index:10;
    background-color: white;
}
.fijo2{
    position:sticky; 
    left:0;
    top: 0;
    z-index:9;
    background-color:white;
    /* border-left: solid 1px #ccc;
    border-right: solid 1px #ccc; */
}

</style>
<template>
    <div class="col backgroundForm">
        <div class="col col-md-6 offset-md-3">
            <div class="alert alert-danger" role="alert">
                <h4 class="alert-heading" align="center">Cuadro de Orden de Operacion</h4>                       
            </div>            
        </div>
        <div class="row">
            <div class="form-group col-12 col-md-4 offset-md-4">
                <label for="t_file">Gestión</label>
                <select id="t_document" class="form-control" v-model="year_select_resume">
                    <option v-for="yv in year_option_resume" :key="yv.id" :value="yv.id">{{ yv.anio }}</option>
                </select>
            </div>
        </div>
        <button class="col col-md-2 offset-md-5 btn btn-success" @click="callCaptains()"> <font-awesome-icon icon="sync-alt" size="lg" /> </button>
        <br>
        <button class="col col-md-2 offset-md-5 btn btn-info" @click="mCopyToClipboard(table_ordops_id)" v-if="table_results!=='' && table_results!==null "> <font-awesome-icon icon="copy" size="lg" /> Copiar</button>
        <br><br>
        <div class="table-responsive" :id="table_ordops_id">
            <table class="table table-bordered table-hover"  v-html="table_results">
                
            </table>
        </div>
        

    <modal-loading :id-modal="id_modal_progress" :title="title_modal" :status-send="send_dispatch" ></modal-loading>
    </div>
</template>

<script>
import Vue from 'vue'
import axios from 'axios'
const qs= require('qs');

import modalLoading from '../modal/modalLoading';

export default {
    name:'ordop-resume',
    data(){
        return{
            table_ordops_id:'ordops_table',
            updateTable:null,
            dtsTable:[],
            initOrdop:[],
            resultOrdop:[],
            id_modal_progress:'idTableResume',
            title_modal:'Cargando',
            send_dispatch:true,
            year_option_resume:[],
            year_select_resume:0,
            table_results:null,
            dtsCaptain:[]
        }
    },
    mounted(){
        this.getYears();
        this.callTypesOrdop();
    },
    beforeDestroy(){
        this.destroyUpdate();
    },
    methods:{
        mCopyToClipboard(elemento) {

            var $temp = $("<input>")
            $("body").append($temp);
            // console.log($(`#${elemento}`));
            $temp.val($(`#${elemento}`).html()).select();
            document.execCommand("copy");
            $temp.remove();
            toastr.info('Tabla copiada con exito', 'Archivo copiado')
        },
        async callTypesOrdop(){
            
            // this.activeModal(this.id_modal_progress);

            let or=await axios.get(`globals/ordop?api_token=${Vue.auth.getToken()}`);
            let oi=await axios.get(`globals/ordopinit?api_token=${Vue.auth.getToken()}`);

                // console.log(od);
            this.initOrdop=oi.data;
            this.resultOrdop=or.data;
            console.log(this.initOrdop);
            console.log(this.resultOrdop);

            // setTimeout(()=>{
            //     this.inactiveModal(this.id_modal_progress);
            // },1000)
            
        },
        async callCaptains(){            
            if(this.year_select_resume>0){
                this.destroyUpdate();
                try {
                    console.log('llamamos una vez al cuadro');
                        // let dtsCaptain=await axios.get();
                        let dtsOrdops=await axios.get(`getAllOrdops/${this.year_select_resume}?api_token=${Vue.auth.getToken()}`);
                        
                        this.dtsCaptain=dtsOrdops.data;
                        
                        this.armTable();
                        this.updateTable=setInterval(async ()=>{
                            try {
                                console.log('actualizamos el cuadro');
                                let dtsOrdops=await axios.get(`getAllOrdops/${this.year_select_resume}?api_token=${Vue.auth.getToken()}`);
                                
                                this.dtsCaptain=dtsOrdops.data;
                                
                                this.armTable();
                            } catch (error) {
                                console.log(error)
                            }
                        }, 900000) 
                } catch (error) {
                    console.log(error)
                }
            }else{
                toastr.warning('Seleccione una Gestion', 'Error');
            }      
        },
        mRandomColor(){
            let randomBetween = (min, max) => min + Math.floor(Math.random() * (max - min + 1));
            let r = randomBetween(0, 255);
            let g = randomBetween(0, 255);
            let b = randomBetween(0, 255);
            let old_color = `rgb(${r},${g},${b}, 0.2 )`; 
            return old_color;
        },
        armTable(){
            let cio=this.initOrdop.length;
            let cro=this.resultOrdop.length;
            
            let captain_color=this.mRandomColor();
            let ordop_i_color=this.mRandomColor();
            let ordop_res_color=this.mRandomColor();
            let ordop_tot_init_col=this.mRandomColor();
            let ordop_tot_res_col=this.mRandomColor();

            let tableAux=`<thead class="fijo" style="position:sticky; top:0; z-index:10;     background-color: white;"><tr>
                            <th scope="col" rowspan="2" class="align-middle text-center" style="background-color:${captain_color}">#</th>
                            <th scope="col" rowspan="2" class="align-middle text-center" style="background-color:${captain_color}">CAPITANIA</th>
                            <th scope="col" colspan="${cio}" align="center" class="text-center" style="background-color:${ordop_i_color}">ORDOP Inicial</th>
                            <th scope="col" colspan="${cro}" align="center" class="text-center" style="background-color:${ordop_res_color}">Resultados ORDOP</th>
                            <th scope="col" rowspan="2" class="align-middle text-center" style="background-color:${ordop_tot_init_col}"># APERTURADAS</th>
                            <th scope="col" rowspan="2" class="align-middle text-center" style="background-color:${ordop_tot_res_col}"># RESULTADOS</th>
                          </tr>
                          <tr>`;
            this.initOrdop.forEach(oi => {
                tableAux+=`<th scope="col" class="text-center" style="background-color:${ordop_i_color}; position:sticky; top:0; z-index:10;">${oi.detail}</th>`
            });
            this.resultOrdop.forEach(ro => {
                tableAux+=`<th scope="col" class="text-center" style="background-color:${ordop_res_color}; position:sticky; top:0; z-index:10; ">${ro.detail}</th>`
            });
            tableAux+=`</thead><tbody>`
            // recorremos las capitanias

            let sumTotalIni=0;
            let sumTotalRes=0;
            this.dtsCaptain.forEach((captain, index)=>{
                tableAux+=`<tr><th scope="row" class="align-middle text-center">${index+1}</th><td class="text-center fijo2" style="position:sticky; left:0; top: 0; z-index:9;     background-color:white;">${captain.capitania}</td>`;
                let resinit=captain.init;
                let resend=captain.results;

                let sumIni=0;
                let sumRes=0;               

                this.initOrdop.forEach((oi, index) => {
                    // oi.id         
                    let quantityInit=0;
                    if(resinit.length > 0){
                        resinit.forEach((oic)=>{
                            if(oi.id===oic.id){
                                quantityInit=oic.cantidad;
                                
                            }
                        })
                        if(quantityInit>0){
                            tableAux+=`<td class="align-middle text-center">${quantityInit}</td>`;
                            sumIni+=parseInt(quantityInit);
                            sumTotalIni+=parseInt(quantityInit);
                        }else{
                            tableAux+=`<td class="align-middle text-center">----</td>`;
                        }
                        
                    }else{
                        tableAux+=`<td class="align-middle text-center">----</td>`;
                    }

                });

                this.resultOrdop.forEach((roe, index) => {
                    // roe.id                  
                    let quantityResult=0;
                    if(resend.length > 0){
                        resend.forEach((orc)=>{
                            if(roe.id === orc.id){
                                quantityResult=orc.cantidad;   
                            }
                        })
                        if(quantityResult>0){
                            tableAux+=`<td class="align-middle text-center">${quantityResult}</td>`;
                            sumRes+=parseInt(quantityResult);
                            sumTotalRes+=parseInt(quantityResult);
                        }else{
                            tableAux+=`<td class="align-middle text-center">----</td>`;
                        }
                    }else{
                        tableAux+=`<td class="align-middle text-center">----</td>`;
                    }
                });

                tableAux+=`<td class="align-middle text-center">${sumIni}</td>`;
                tableAux+=`<td class="align-middle text-center">${sumRes}</td>`;
                tableAux+=`</tr>`;    
            });
            let colsTotal=2+cio+cro;
            tableAux+=`<tr><th colspan="${colsTotal}" scope="row" class="align-middle text-center">TOTAL</th><td class="align-middle text-center">${sumTotalIni}</td><td class="align-middle text-center">${sumTotalRes}</td></tr></tbody>`;
            this.table_results=tableAux;
        },
        getYears(){
            this.year_option_resume=[];
            let anio=new Date();
            let current_year=anio.getFullYear();
            let old_year=anio.getFullYear()-10;
            for(let i = old_year ; i<=current_year ;i++){
                let auxYear={
                    id:i,
                    anio:i
                }
                this.year_option_resume.push(auxYear);
            }
        },
        destroyUpdate(){
            console.log('destruyendo el evento');
            clearInterval(this.updateTable);
        },
        activeModal(e){
            $(`#${e}`).modal('show');
        },
        inactiveModal(e){
            $(`#${e}`).modal('hide');
        }
    },
    components:{
        'modal-loading':modalLoading
    },
}
</script>




// WEBPACK FOOTER //
// src/components/ordop/OrdopResume.vue